import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalAllstatus } from "../../../store/reducer/globalDropdownSearch..reducer";
import { setGlobalErrors } from "../../../store/reducer/globalErrors.reducers";

const DDSAllStatus = ({ className, togglerClassName, ...attrs }) => {
  const dispatch = useDispatch();

  const { globalErrors } = useSelector((state) => state.globalErrors);

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [status, setStatus] = useState(null);

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (evt) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(evt?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const onClickSelectedData = useCallback(
    (item) => {
      const errors = { ...globalErrors };
      if (errors?.status) {
        delete errors.status;
        dispatch(setGlobalErrors(errors));
      }

      setStatus(item);
      setIsShowDropdownContent(false);
      dispatch(setGlobalAllstatus(item));
    },
    [dispatch, globalErrors]
  );

  const listStatus = useMemo(() => {
    const list = [
      { value: "ALL", label: "All Status" },
      { value: "Paid", label: "Paid" },
      { value: "Unpaid", label: "Unpaid" },
    ];
    return list;
  }, []);

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      ref={dropdownRef}
      {...attrs}
    >
      <button
        className={"value-mss"}
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
      >
        {!status || status === null ? (
          <span className="placeholder-mss">Select Status</span>
        ) : (
          <span className="font-roboto text-xl font-medium text-[#424242]">
            {status?.label}
          </span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="overflow-auto max-h-[300px]">
          {listStatus.map((el, idx) => {
            return (
              <div
                key={idx}
                className={"dropdown-dds-item truncate"}
                onClick={() => onClickSelectedData(el)}
              >
                <div className="w-full flex justify-between px-2">
                  <span>{el?.label}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DDSAllStatus;
